export const FETCH_INTEGRATION_LOGS_REPORT = "FETCH_INTEGRATION_LOGS_REPORT";
export const FETCH_INTEGRATION_LOGS_REPORT_SUCCESS = "FETCH_INTEGRATION_LOGS_REPORT_SUCCESS";
export const FETCH_INTEGRATION_LOGS_REPORT_FAILED = "FETCH_INTEGRATION_LOGS_REPORT_FAILED";

export const DOWNLOAD_INTEGRATION_LOGS_REPORT = "DOWNLOAD_INTEGRATION_LOGS_REPORT";
export const DOWNLOAD_INTEGRATION_LOGS_REPORT_SUCCESS =
  "DOWNLOAD_INTEGRATION_LOGS_REPORT_SUCCESS";
export const DOWNLOAD_INTEGRATION_LOGS_REPORT_FAILED =
  "DOWNLOAD_INTEGRATION_LOGS_REPORT_FAILED";
